export const NON_STANDARD_SHIP_OPTIONS_MAP = {
  '1-Business Day': 'Fastest',
  '2-Business Days': 'Faster',
  '3-5 Business Days': 'Fast',
  '3-7 Business Days': 'Fast',
  '5-10 Business Days': 'Fast',
  '5-7 Business Days': 'Fast'
};

export const DYNAMIC_VIP_SHIP_OPTIONS_MAP = {
  '1-Business Day': 'Default Shipping',
  '2-Business Days': 'Featured Shipping Option',
  '3-5 Business Days': 'Shipping Option',
  '3-7 Business Days': 'Shipping Option',
  '5-10 Business Days': 'Shipping Option',
  '5-7 Business Days': 'Shipping Option'
};

export const DYNAMIC_PRIME_SHIP_OPTIONS_MAP = {
  '1-Business Day': 'Additional Shipping Option',
  '2-Business Days': 'Default Shipping',
  '3-5 Business Days': 'Standard Zappos Shipping',
  '3-7 Business Days': 'Standard Zappos Shipping',
  '5-10 Business Days': 'Standard Zappos Shipping',
  '5-7 Business Days': 'Standard Zappos Shipping'
};

export const DYNAMIC_NO_PERK_SHIP_OPTIONS_MAP = {
  '1-Business Day': 'Shipping Option',
  '2-Business Days': 'Featured Shipping Option',
  '3-5 Business Days': 'Default Shipping',
  '3-7 Business Days': 'Default Shipping',
  '5-10 Business Days': 'Default Shipping',
  '5-7 Business Days': 'Default Shipping'
};
